import { ExtensibleActivity } from 'app/model/pipeline/extensible.activity';
import { Activity, format, IValidationContext, IViolation, LinkedService, LogicAppsProperty, Metamodel, shellStringResources, validateLinkedServicePermission } from 'shell-models-lib';

export type HTTP_VERBS = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

export class WebExtensibleUtil {

    public static async validateConnection(
        pipelineActivity: Activity,
        connection: LinkedService,
        violation: IViolation,
        context: IValidationContext
    ): Promise<IViolation[]> | undefined {
        return (connection) ? validateLinkedServicePermission(connection, context) : [];
    }
    
    /**
     * @deprecated Kept only for documentation purposes
     */
    public static validateProperties(activity: ExtensibleActivity): IViolation[] {
        const result: IViolation[] = [];
        const properties = this.propertiesIncludingChildren(activity.properties);
        properties.forEach((property) => {
            const attribute = Metamodel.modelOf(property).attribute('value');
            if (property.required && !attribute.templateValue(property) && !property.value && !property.children.length) {
                result.push({
                    context: activity,
                    message: () => format(shellStringResources.RequiredValidatorMessageNoVowel, Metamodel.modelOf(activity).display[0], activity.name, property.label),
                    attributes: [attribute]
                });
            }

            if (property.minimum !== undefined && property.value < property.minimum) {
                result.push({
                    context: activity,
                    message: () => format(shellStringResources.MinMaxValidatorMessageMinimum, Metamodel.modelOf(activity).display[0] + ' ' + activity.name, property.label, property.value.toString(), property.minimum.toString()),
                    attributes: [attribute]
                });
            }

            if ((property.loading || property.loadingChildren) && property.loadingMessage) {
                result.push({
                    context: activity,
                    message: () => format(stringResources.ExtensibleValidation, Metamodel.modelOf(activity).display[0], activity.name, property.loadingMessage),
                    attributes: [attribute]
                });
            }
        });
        return result;
    }

    private static propertiesIncludingChildren(array: LogicAppsProperty[]): LogicAppsProperty[] {
        let result: LogicAppsProperty[] = [];
        array.forEach((item) => {
            result.push(item);
            if (item.children) {
                result = result.concat(this.propertiesIncludingChildren(item.children));
            }
        });
        return result;
    }

}